<taly-banner />

<div class="container">
    <taly-features />
    <taly-how-it-work />

    <!-- [TODO] : as requested on 24 May 2025 from sulaiman we are hiding temparary later will enable, so dont delete this code -->
    <!-- <taly-partners /> -->
    
    <taly-home-faq />
    <taly-app-details />
    <taly-taly-business />

</div>